<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">停车场详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="停车场编号" prop="Code">
                <el-input v-model="data.Code" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="停车场名称" prop="Name">
                <el-input v-model="data.Name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="总车位数" prop="TotalPlace">
                <el-input v-model="data.TotalPlace" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="剩余车位数" prop="LeftPlace">
                <el-input v-model="data.LeftPlace" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="已使用车位数" prop="UsedSpace">
                <el-input v-model="data.UsedSpace" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="Longitude">
                <el-input v-model="data.Longitude" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="纬度" prop="Latitude">
                <el-input v-model="data.Latitude" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <ZjLngLatSelect
              class="newtaskposition"
              :point_lat="data.Latitude"
              :point_lng="data.Longitude"
              @onGotLngLat="onGotLngLat"
            ></ZjLngLatSelect>
            <!-- <el-button @click="getCurrentPostion()" style="margin-left:1.5rem;">定位</el-button> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="Contact">
                <el-input v-model="data.Contact" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="Phone">
                <el-input v-model="data.Phone" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="saveForm()" :disabled="!IsEdit" v-if="IsEdit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "ScenicCarParkManagerEdit",
  controller: "UI",
  action: "ScenicCarParkManagerEdit",
  data() {
    return {
      data: {
        Latitude: "",
        Longitude: ""
      },
      IsEdit: false,
      rules: {
        Code: [{ required: true, message: "请输入车场编号", trigger: "blur" }],
        Name: [
          { required: true, message: "请输入停车场名称", trigger: "blur" }
        ],
        Longitude: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        Latitude: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        TotalPlace: [
          {
            required: true,
            message: "请选输入有效的总车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/
          }
        ],
        LeftPlace: [
          {
            required: true,
            message: "请选输入有效的剩余车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/
          }
        ],
        UsedSpace: [
          {
            required: true,
            message: "请选输入有效的已用车位数",
            trigger: "blur",
            pattern: /^(0|[1-9]\d*)$/
          }
        ]
      }
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    onGotLngLat(obj) {
      this.data.Latitude = obj.lat || 0;
      this.data.Longitude = obj.lng || 0;
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        new MyApis.TranResourcesApi()
          .GetCarParkById(InfoId)
          .then(r => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          Status: 0, //0离线，1在线
          Id: uuid
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    }
  }
};
</script>
